/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/* -----------------*/
/* Custom Mega Menu */
/* -----------------*/
/* Get Announcement Bar once, so we don't have to query the DOM every time */
var announcementBar = document.querySelector('.AnnouncementBar') || null;
var announcementBarHeight = announcementBar ? announcementBar.offsetHeight : 0;

/* Calculate visibility of the Announcement bar, relative to scrolling */
/* We use this to calculate the position of the Custom Mega Menu's fixed top position */
function calculateAnnouncementBarPosition() {
  if (!announcementBar || window.scrollY > 100) { /* Optimization: Don't calculate if the user has scrolled down more than 100px */
    return;
  }

  const announcementBarPosition = (announcementBar.getBoundingClientRect().y * -1);
  const calculated = announcementBarPosition > announcementBarHeight ? announcementBarHeight : Math.min(announcementBarPosition, announcementBarHeight);

  document.documentElement.style.setProperty('--announcement-bar-relative-position', calculated + 'px')
}

/* Call the calculation above on page load. No need for DOMContentLoaded, as custom.js is deferred */
calculateAnnouncementBarPosition();

/* Add scroll event listener to the window for the calculation above */
window.addEventListener('scroll', function() {
  calculateAnnouncementBarPosition();
});

/* Custom Mega Menu component - handle onhover navigation change */
var CustomMegaMenu = class CustomMegaMenu extends HTMLElement {
  constructor() {
    super();

    this.navItems = this.querySelectorAll('.CustomMegaMenu__TopLevel .CustomMegaMenu__Link');

    for (const navItem of this.navItems) {
      navItem.addEventListener('mouseover', this.changeActiveSubNav.bind(this))
    }
  }

  changeActiveSubNav(event) {
    const targetAttr = event.target.dataset.openerFor;
    const newTarget = this.querySelector(`[data-linked-to="${ targetAttr }"]`);
    const previousExpanded = this.querySelector('.CustomMegaMenu__Link[aria-expanded="true"]');
    const previousActiveElement = this.querySelector('.CustomMegaMenu__SubNavigation[aria-hidden="false"]');

    event.target.setAttribute('aria-expanded', 'true');

    if (previousExpanded) {
      previousExpanded.setAttribute('aria-expanded', 'false');
    }

    if (previousActiveElement) {
      previousActiveElement.setAttribute('aria-hidden', 'true');
    }

    if (newTarget) {
      newTarget.setAttribute('aria-hidden', 'false');
    }
  }
}

window.customElements.define('custom-mega-menu', CustomMegaMenu);

/* ----------------*/
/* Add to Cart CTA */
/* ----------------*/
var AddToCart = class AddToCart extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector('form');
    this.variantId = this.form.querySelector('[name="id"]').value;
    this.quantity = this.form.querySelector('[name="quantity"]').value;

    this.form.addEventListener('submit', this.addToCart.bind(this));
  }

  addToCart(event) {
    event.preventDefault();

    fetch(window.routes.cartAddUrl, {
      method: 'POST',
      body: JSON.stringify({
        id: this.variantId,
        quantity: this.quantity
      }),
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    }).then(function (response) {
      if (response.ok) {
        document.documentElement.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: {
            variant: this.variantId,
            quantity: this.quantity
          }
        }));
      }
    }.bind(this));
  }
}

window.customElements.define('add-to-cart', AddToCart);

/* ----------------*/
/* Custom Dropdown */
/* ----------------*/
var CustomDrowpdown = class CustomDrowpdown extends HTMLElement {
  constructor() {
    super();

    /* Attributes */
    this.functionality = this.getAttribute('data-functionality');
    this.optionIndex = this.getAttribute('data-option-index') || null;
    this.shapeType = this.getAttribute('data-for') || null;

    /* Elements */
    this.opener = this.querySelector('.Dropdown__Opener');
    this.content = this.querySelector('.Dropdown__Content');
    this.selectedValueContainer = this.querySelector('.Dropdown__SelectedValue') || null;
    this.customSizes = document.querySelector('custom-width-height');

    /* Variant data */
    this.variantData = JSON.parse(document.querySelector('[data-product-json]').innerHTML);
    this.previousVariant = this.variantData.product.variants.find(function (variant) {
      return variant.id === this.variantData.selected_variant_id;
    }.bind(this));

    /* Common Event listeners */
    this.opener.addEventListener('click', this.toggleDropdown.bind(this));
    this.addEventListener('blur', this.closeDropdown.bind(this));
    this.addEventListener('variant:changed', function(event) {
      this.previousVariant = event.detail.variant.id; 
    }.bind(this));

    /* Functionality specific event listeners */
    if (this.functionality === 'product_option' && this.optionIndex !== null) {
      this.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', this.changeProductOption.bind(this));
      }.bind(this));
    }

    if (this.functionality === 'quantity') {
      this.querySelectorAll('input[type="radio"]').forEach(function (radio) {
        radio.addEventListener('change', this.changeProductQuantity.bind(this));
      }.bind(this));

      document.addEventListener('shape:changed', function(event) {
        const shape = event.detail.shape;

        /* we hide and disable the other quantity inputs */
        if (shape !== this.shapeType) {
          this.setAttribute('hidden', '');
          this.querySelector('[name="quantity"]').setAttribute('disabled', '');
          return;
        }

        /*console.log('Shape changed to: ' + shape);
        console.log(this);*/

        if (shape === 'Vrije vorm') {
          /* If we are on custom shape, we load the custom contact form and hide everything else */
          /* We don't want to re-enable quantity input here, because we will not be adding anything to the cart anyways */
          const toHideElements = this.closest('.Product__Info').querySelectorAll('.ProductForm > *:not(.ProductMeta, .ProductForm__ShapeSelectorWrapper, .CustomShapeForm)');
          const toShowElement = this.closest('.Product__Info').querySelector('.CustomShapeForm');

          for (const elem of toHideElements) {
            elem.setAttribute('hidden', '');
          }

          if (toShowElement) {
            toShowElement.removeAttribute('hidden');
          }
        } else {
          /* otherwise we show and enable the current quantity input */
          this.removeAttribute('hidden');
          this.querySelector('[name="quantity"]').removeAttribute('disabled');

          const toHideElements = this.closest('.Product__Info').querySelectorAll('.ProductForm > *:not(.ProductMeta, .ProductForm__ShapeSelectorWrapper, .CustomShapeForm)');
          const toShowElement = this.closest('.Product__Info').querySelector('.CustomShapeForm');

          for (const elem of toHideElements) {
            elem.removeAttribute('hidden');
          }

          if (toShowElement) {
            toShowElement.setAttribute('hidden', '');
          }
        }
      }.bind(this));
    }
  }

  toggleDropdown() {
    this.closeOtherDropdowns();

    if (this.content.getAttribute('aria-hidden') === 'true') {
      this.content.setAttribute('aria-hidden', 'false');

      return;
    }

    this.content.setAttribute('aria-hidden', 'true');
  }

  closeDropdown() {
    this.content.setAttribute('aria-hidden', 'true');
  }

  closeOtherDropdowns() {
    const otherDropdowns = document.querySelectorAll('custom-dropdown');

    for (const dropdown of otherDropdowns) {
      if (dropdown !== this) {
        dropdown.closeDropdown();
      }
    }
  }

  changeProductOption(event) {
    this.closeDropdown();

    /* Set the selected value container's text to the selected option */
    if (this.selectedValueContainer) {
      this.selectedValueContainer.innerHTML = event.target.value;
    }

    /* Show/Hide dependant options */
    const triggerOptionName = event.target.name;
    const dependsOnOptions = document.querySelectorAll(`[data-depends-on="${ triggerOptionName }"]`);

    for (const option of dependsOnOptions) {
      let makeVisible = false;
      const dependingValues = option.dataset.dependingValues.split(',');

      for (const value of dependingValues) {
        if (value === event.target.value) {
          makeVisible = true;
          break;
        }
      }

      if (makeVisible) {
        option.setAttribute('aria-hidden', 'false');
      } else {
        option.setAttribute('aria-hidden', 'true');
        
        const previouslySelectedOption = option.querySelector('input[type="radio"]:checked');

        if (previouslySelectedOption) {
          previouslySelectedOption.checked = false;
        }
      }

      if (option.classList.contains('ProductForm__ColorSwatchesWrapper') && option.getAttribute('aria-hidden') === 'true') {
        const firstInput = option.querySelector('input');

        document.dispatchEvent(new CustomEvent('color:changed', {
          bubbles: true,
          detail: {
            color: null
          }
        }));
      }
    }

    /* Find & Update the variant */
    const option1 = document.querySelector('custom-dropdown [name="option-1"]:checked') || null;
    const option2 = document.querySelector('custom-dropdown [name="option-2"]:checked') || null;
    const option3 = document.querySelector('custom-dropdown [name="option-3"]:checked') || null;

    const selectedOptions = {
      option1: option1 !== null ? (option1.value !== '' ? option1.value : null) : null,
      option2: option2 !== null ? (option2.value !== '' ? option2.value : null) : null,
      option3: option3 !== null ? (option3.value !== '' ? option3.value : null) : null
    }
    
    let selectedVariantName = '';

    for (let i = 0; i < Object.keys(selectedOptions).length; i++) {
      const currentProperty = selectedOptions[`option${ i + 1 }`];
      const nextPropety = selectedOptions[`option${ i + 2 }`];

      if (typeof currentProperty !== 'undefined' && currentProperty !== null) {
        if (typeof nextPropety !== 'undefined' && nextPropety !== null) {
          selectedVariantName += currentProperty + ' / ';
        } else {
          selectedVariantName += currentProperty;
        }
      }
    }

    let selectedVariant = null;

    for (const variant of this.variantData.product.variants) {
      if (variant.title === selectedVariantName) {
        selectedVariant = variant;

        break;
      }
    }

    if (selectedVariant !== null) {
      document.querySelector('[name="id"]').value = selectedVariant.id;

      /* To support the same event as Prestige sends by default */
      this.dispatchEvent(new CustomEvent('variant:changed', {
        bubbles: true,
        detail: {
          variant: selectedVariant,
          previousVariant: this.previousVariant
        }
      }));
    }
  }

  changeProductQuantity(event) {
    /* First we close the dropdown */
    this.closeDropdown();

    /* Then we update the selected value text if there's a container for it */
    if (this.selectedValueContainer) {
      this.selectedValueContainer.innerHTML = event.target.value;
    }

    /* Then we reset the custom sizes inputs */
    if (this.customSizes) {
      this.customSizes.querySelectorAll('input').forEach(function (input) {
        input.value = '';
      });
    }

    /* Then we set the quantity */
    const minQty = this.querySelector('[name="quantity"]').getAttribute('min');
    const newValue = event.target.dataset.value !== 'placeholder' ? event.target.dataset.value : minQty;

    this.querySelector('[name="quantity"]').value = newValue < minQty ? minQty : newValue;
    
    /* Update price display and sync sticky bar */
    updatePriceDisplay();
    syncStickyBarQuantity();
  }

  showRelevantSelector() {

  }
}

window.customElements.define('custom-dropdown', CustomDrowpdown);

/* -----------------------*/
/* Custom Width / Height */
/* ----------------------*/
var CustomWidthHeight = class CustomWidthHeight extends HTMLElement {
  constructor() {
    super();

    this.widthInput = this.querySelector('[name="properties[Breedte]"]') || null;
    this.heightInput = this.querySelector('[name="properties[Lengte]"]') || null;
    //this.sizeDropdown = document.querySelector('custom-dropdown[data-functionality="quantity"]') || null;

    if (this.widthInput) {
      this.widthInput.addEventListener('input', function (event) {
        this.changeProductQuantityCustom(event, 'width');
      }.bind(this));
    }

    if (this.heightInput) {
      this.heightInput.addEventListener('input', function (event) {
        this.changeProductQuantityCustom(event, 'height');
      }.bind(this));
    }
  }

  changeProductQuantityCustom(event, axis) {
    /* First we update the input value */
    if (axis === 'width') {
      this.widthInput.value = event.target.value;
    } else {
      this.heightInput.value = event.target.value;
    }

    const sizeDropdown = document.querySelector('custom-dropdown[data-functionality="quantity"]:not([hidden])') || null;
    let shapeType = null;

    if (sizeDropdown) {
      shapeType = sizeDropdown.getAttribute('data-for');
    }

    /* Then we reset the standard size value */
    if (sizeDropdown) {
      sizeDropdown.querySelector('[data-placeholder]').checked = true;

      const selectedValueContainer = sizeDropdown.querySelector('.Dropdown__SelectedValue');

      if (selectedValueContainer) {
        selectedValueContainer.innerHTML = '';
      }
    }

    /* Then we calculate the new quantity */
    const currentWidth = this.widthInput.value;
    const currentHeight = this.heightInput.value;
  
    /* If we are on circle, we make the two inputs identical */
    if (shapeType === 'Rond') {
      const biggerSide = currentHeight > currentWidth ? currentHeight : currentWidth;

      this.widthInput.value = biggerSide;
      this.heightInput.value = biggerSide;
    }

    const minQty = document.querySelector('[name="quantity"]:not([disabled])').getAttribute('min');
    let roundedQty = null;

    switch (shapeType) {
      case 'Recht':
        roundedQty = Math.round((currentWidth * currentHeight) / 100);
        break;
      case 'Rond':
        const radius = this.widthInput.value / 2; /* doesn't matter whether we choose width or height, because by this time they are identical */
        roundedQty = Math.round((Math.PI * Math.pow(radius, 2)) / 100);
        break;
      case 'Vrije vorm':
        roundedQty = Math.round((currentWidth * currentHeight) / 100); /* Placeholder for now, until we have a formula to work with */
        break;
      default:
        roundedQty = minQty;
        break;
    }

    const calculatedQty = (isNaN(roundedQty) === false ? roundedQty : minQty);

    document.querySelector('[name="quantity"]:not([disabled])').value = calculatedQty < minQty ? minQty : calculatedQty;
    
    /* Update price display and sync sticky bar */
    updatePriceDisplay();
    syncStickyBarQuantity();
  }
}

window.customElements.define('custom-width-height', CustomWidthHeight);

/* ---------------*/
/* Price Display  */
/* ---------------*/
function syncStickyBarQuantity() {
  const mainQuantityInput = document.querySelector('.ProductForm [name="quantity"]:not([disabled])');
  const stickyQuantityInput = document.querySelector('#ProductStickyBar__Quantity');
  
  if (mainQuantityInput && stickyQuantityInput) {
    stickyQuantityInput.value = mainQuantityInput.value;
  }
}

function updatePriceDisplay() {
  const priceDisplays = document.querySelectorAll('[data-base-price]');
  const quantityInput = document.querySelector('[name="quantity"]:not([disabled])');
  
  if (!priceDisplays.length || !quantityInput) {
    return;
  }
  
  const quantity = parseInt(quantityInput.value, 10) || 0;
  
  priceDisplays.forEach(function(priceDisplay) {
    const priceDisplayValue = priceDisplay.querySelector('[data-price-display]');
    if (!priceDisplayValue) {
      return;
    }
    
    const basePrice = parseInt(priceDisplay.getAttribute('data-base-price'), 10);
    
    if (basePrice && quantity > 0) {
      const totalPrice = basePrice * quantity;
      const priceInEuros = (totalPrice / 100).toFixed(2);
      const formattedPrice = priceInEuros.replace('.', ',');
      priceDisplayValue.textContent = '€' + formattedPrice;
    }
  });
}

window.addEventListener('DOMContentLoaded', function() {
  const shapeInputs = document.querySelectorAll('.ProductForm__ShapeSelector input');
  const customColorInputs = document.querySelectorAll('.ProductForm__ColorSwatchesWrapper input');

  for (const input of shapeInputs) {
    input.addEventListener('change', function(event) {
      if (!event.target.checked) {
        return;
      }

      document.dispatchEvent(new CustomEvent('shape:changed', {
        bubbles: true,
        detail: {
          shape: event.target.value
        }
      }));
    });
  }

  for (const input of customColorInputs) {
    input.addEventListener('change', function(event) {
      if (!event.target.checked) {
        return;
      }

      console.log('sending color change event');
      document.dispatchEvent(new CustomEvent('color:changed', {
        bubbles: true,
        detail: {
          color: event.target.value.replaceAll(' ', '_').toLowerCase()
        }
      }));
    });
  }

  // init
  const checkedShapeInput = document.querySelector('.ProductForm__ShapeSelector input:checked');
  const checkedColorInput = document.querySelector('.ProductForm__ColorSwatchesWrapper input:checked');

  if (checkedShapeInput) {
    document.dispatchEvent(new CustomEvent('shape:changed', {
      bubbles: true,
      detail: {
        shape: checkedShapeInput.value
      }
    }));
  }

  if (checkedColorInput) {
    document.dispatchEvent(new CustomEvent('color:changed', {
      bubbles: true,
      detail: {
        color: checkedColorInput.value.value.replaceAll(' ', '_').toLowerCase()
      }
    }));
  }

  document.addEventListener('color:changed', function(event) {
    const color = event.detail.color;

    if (color === null) {
      const allSlides = document.querySelectorAll('.Product__SlideItem');

      for (let i = 0; i < allSlides.length; i++) {
        const slide = allSlides[i];

        if (i === 0) {
          slide.classList.add('is-selected');
          slide.removeAttribute('hidden');

          continue;
        }

        slide.classList.remove('is-selected');
        slide.setAttribute('hidden', '');
      }

      const flickityNav = document.querySelector('.Product__SlideshowMobileNav');

      flickityNav?.setAttribute('hidden', '');

      const slideshow = Flickity?.data('.Product__Slideshow');

      if (slideshow) {
        slideshow.element.style.pointerEvents = 'all';

        slideshow.reloadCells();
        slideshow.resize();
        slideshow.selectCell(0);
      }

      return;
    }

    const currentlyActiveImage = document.querySelector('.Product__SlideItem.is-selected');
    const nonCustomImages = document.querySelectorAll('.Product__SlideItem:not([id^="Media-custom-swatch"])');
    const targetImage = document.querySelector(`.Product__SlideItem[id$="${ color }"]`);
    const flickityIndex = Number(targetImage.getAttribute('data-image-media-position'));
    const flickityNav = document.querySelector('.Product__SlideshowMobileNav');

    if (!currentlyActiveImage || !targetImage || currentlyActiveImage === targetImage) {
      return;
    }

    currentlyActiveImage.classList.remove('is-selected');
    currentlyActiveImage.setAttribute('hidden', '');

    targetImage.classList.add('is-selected');
    targetImage.removeAttribute('hidden');

    for (const image of nonCustomImages) {
      image.setAttribute('hidden', '');
    }

    flickityNav?.setAttribute('hidden', '');

    const slideshow = Flickity?.data('.Product__Slideshow');

    if (slideshow) {
      slideshow.element.style.pointerEvents = 'none';

      slideshow.reloadCells();
      slideshow.resize();
      slideshow.selectCell(flickityIndex);
    }
  });
  
  // Price display updates - sync quantity and price
  const quantityInput = document.querySelector('[name="quantity"]:not([disabled])');
  if (quantityInput) {
    quantityInput.addEventListener('input', function() {
      updatePriceDisplay();
      syncStickyBarQuantity();
    });
    quantityInput.addEventListener('change', function() {
      updatePriceDisplay();
      syncStickyBarQuantity();
    });
  }
  
  document.addEventListener('variant:changed', function(event) {
    const priceDisplays = document.querySelectorAll('[data-base-price]');
    const variantIdInputs = document.querySelectorAll('[name="id"]');
    
    if (event.detail.variant?.price) {
      priceDisplays.forEach(function(priceDisplay) {
        priceDisplay.setAttribute('data-base-price', event.detail.variant.price);
      });
      
      variantIdInputs.forEach(function(input) {
        input.value = event.detail.variant.id;
      });
      
      updatePriceDisplay();
    }
  });
  
  updatePriceDisplay(); // Initial load
  syncStickyBarQuantity(); // Initial sync
});



document.addEventListener("submit", function (e) {
  const form = e.target;
  if (!(form instanceof HTMLFormElement)) return;
  if (!form.matches('form[action^="/cart/add"]')) return;

  // Zoek binnen het productform naar de custom quantity selector
  // (werkt voor veel custom blocks: input/select met 'placeholder' of lege waarde)
  const placeholderEl =
    form.querySelector('[data-placeholder="true"]') ||
    form.querySelector('select option[value="placeholder"]:checked') ||
    form.querySelector('select option:checked') ||
    null;

  // Specifiek: check op value "placeholder" of tekst "Kies afmeting"/"Standaardafmeting"
  let isPlaceholderSelected = false;

  // Case: select
  const select = form.querySelector('select[name*="properties"], select[name*="quantity"], select');
  if (select) {
    const val = (select.value || "").toLowerCase();
    const txt = (select.options[select.selectedIndex]?.textContent || "").trim().toLowerCase();
    if (val === "placeholder" || val === "" || txt === "standaardafmeting" || txt === "kies afmeting") {
      isPlaceholderSelected = true;
    }
  }

  // Case: custom input (sommige selectors schrijven "placeholder" in een hidden input)
  const hidden = form.querySelector('input[type="hidden"][value="placeholder"], input[type="hidden"][value="Standaardafmeting"]');
  if (hidden) isPlaceholderSelected = true;

  if (isPlaceholderSelected) {
    e.preventDefault();
    e.stopPropagation();

    // nette inline foutmelding (minimaal)
    let err = form.querySelector(".nw-size-error");
    if (!err) {
      err = document.createElement("div");
      err.className = "nw-size-error";
      err.setAttribute("role", "alert");
      err.textContent = "Selecteer een afmeting om verder te gaan.";
      form.prepend(err);
    }

    err.scrollIntoView({ behavior: "smooth", block: "center" });
  }
}, true);

